import {GoToDestinationActionGoTo, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum PortalGoToDestinationZoomType {
	ZoomPage = "zoomPage",
	FitPage = "fitPage",
	FitBoundingBox = "fitBoundingBox",
	FitBoundingBoxWidth = "fitBoundingBoxWidth",
	FitWidth = "fitWidth",
	FitHeight = "fitHeight",
	FitRectangle = "fitRectangle",
	GoToNamed = "goToNamed"
}

export class PortalGoToDestinationActionGoTo extends GoToDestinationActionGoTo implements Parameter {
	public zoomType?: PortalGoToDestinationZoomType;

	constructor(data: any) {
		super(data);

		this.zoomType = FunctionHelper.exists(data?.zoomType) ? data.zoomType : PortalGoToDestinationZoomType.FitBoundingBox;
	}

	public static getZoomTypeDefault(): PortalGoToDestinationZoomType {
		return PortalGoToDestinationZoomType.FitBoundingBox;
	}

	public static fromJson(data: any): PortalGoToDestinationActionGoTo {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalGoToDestinationActionGoTo(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'zoomType': this.zoomType
		};
	}

	public clone(): PortalGoToDestinationActionGoTo {
		return PortalGoToDestinationActionGoTo.fromJson(this.toJson());
	}
}